const attrs = {
  name: "",
  updated_at: "",
  query_parameters: [],
  firebase_enabled: false,
  firebase_host: "",
  firebase_parameter: []
};

const options = {
  pathName: "query-maps",
  parentType: "spaces",
  parentKey: "space_id"
};

const getters = {
  queryMapById: state => query_map_id => {
    return state.content.filter(query_map => query_map.id === query_map_id)[0];
  },
  queryMaps: state => {
    return state.content.map(({ id, name }) => ({
      id,
      name
    }));
  },
  urlMapFieldIds: state => query_map_id => {
    const queryMap = state.content.filter(
      entry => entry.id === query_map_id
    )[0];
    if (!queryMap || !queryMap.query_parameters) return [];

    let nested = queryMap.query_parameters.map(field => {
      return field.template
        .filter(parameter => parameter.type === "field")
        .map(parameter => {
          return parameter.value;
        });
    });

    state.content[0].firebase_parameter = state.content[0].firebase_parameter
      ? state.content[0].firebase_parameter
      : [];
    let nested_firebase = state.content[0].firebase_parameter.map(field => {
      return field.template
        .filter(parameter => parameter.type === "field")
        .map(parameter => {
          return parameter.value;
        });
    });
    const parameter_field_ids = [].concat.apply([], nested);
    const all_field_ids = parameter_field_ids.concat.apply(
      parameter_field_ids,
      nested_firebase
    );
    return all_field_ids;
  }
};

export default {
  generic: {
    attrs,
    options
  },
  getters
};
